export const DRAWER_WIDTH = 400;
export const NAV_HEIGHT = 64;
